import PrivacyPage from './privacy-page';
export default PrivacyPage;